import { useTaskIntrospectionQuery } from '@common/cache';
import { useEffect } from 'react';
import { useReportStore } from '@store';
import { Report } from './Report.tsx';

export const TasksReport = () => {
  const { setIntrospection } = useReportStore();
  const { data } = useTaskIntrospectionQuery();

  useEffect(() => {
    if (data) {
      setIntrospection(data);
    }
  }, [data]);

  return <Report />;
};
